import logo from './logo.png';
import API_URL from './api';
import { useState } from 'react';
import './App.css';

// R1: Functional Components — Signup is a functional component
// rendered by App.js onto the screen.

// R2: Passing Props — App.js passes onGoToLogin down to Signup.
function Signup({ onGoToLogin }) {

  // R6: React Hooks — useState manages all form fields,
  // current step, and feedback messages.
  const [handle, setHandle] = useState('');
  const [email, setEmail] = useState('');
  const [tosAccepted, setTosAccepted] = useState(false);
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState('details'); // 'details' or 'otp'
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  async function handleSignup() {
    if (!handle || !email || !tosAccepted) {
      setError('Please fill in all fields and accept the Terms of Service');
      return;
    }
    setIsLoading(true);
    setError('');

    try {
      const res = await fetch(`${API_URL}/auth/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ handle, email, tosAccepted }),
      });

      const data = await res.json();

      if (res.ok) {
        setStep('otp');
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError('Could not connect to server');
    }

    setIsLoading(false);
  }

  async function handleVerifyOTP() {
    if (!otp) {
      setError('Please enter your verification code');
      return;
    }
    setIsLoading(true);
    setError('');

    try {
      const res = await fetch(`${API_URL}/auth/verify-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp }),
      });

      const data = await res.json();

      if (res.ok) {
        setStep('success');
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError('Could not connect to server');
    }

    setIsLoading(false);
  }

// Step 1 — Details
  if (step === 'details') {
    return (
      <div>
        <div className="login-header">
          <img src={logo} className="login-logo" alt="ThePinBook" />
          <span className="login-title">ThePinBook</span>
        </div>
        <div className="form-box">
          <h2>Create your account</h2>
          <p className="form-subtitle">Choose your handle and enter your email</p>
          {error && <p className="error">{error}</p>}
          <input
            type="text"
            placeholder="Choose a handle (6 or more letters)"
            value={handle}
            onChange={(e) => setHandle(e.target.value)}
          />
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="tos-row">
            <input
              type="checkbox"
              id="tos"
              checked={tosAccepted}
              onChange={(e) => setTosAccepted(e.target.checked)}
            />
            <label htmlFor="tos">
              I agree to the <span className="link">Terms of Service</span> and <span className="link">Privacy Policy</span>
            </label>
          </div>
          <button onClick={handleSignup} disabled={isLoading}>
            {isLoading ? 'Sending...' : 'Create account'}
          </button>
          <p>Already have an account? <span className="link" onClick={onGoToLogin}>Log in</span></p>
        </div>
      </div>
    );
  }

  // Step 2 — OTP entry
  if (step === 'otp') {
    return (
      <div className="form-box">
        <h2>Verify your email</h2>
        <p className="form-subtitle">We sent a 6-digit code to <strong>{email}</strong></p>
        {error && <p className="error">{error}</p>}
        <input
          type="text"
          placeholder="6-digit code"
          value={otp}
          maxLength={6}
          onChange={(e) => setOtp(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleVerifyOTP()}
        />
        <button onClick={handleVerifyOTP} disabled={isLoading}>
          {isLoading ? 'Verifying...' : 'Verify code'}
        </button>
        <p><span className="link" onClick={() => setStep('details')}>← Back</span></p>
      </div>
    );
  }

  // Step 3 — Success
  return (
    <div className="form-box">
      <h2>✅ Account created!</h2>
      <p className="form-subtitle">Your account is verified and ready to use.</p>
      <br />
      <button onClick={onGoToLogin}>Go to login</button>
    </div>
  );
}

export default Signup;